'use es6';

import { createReducer } from 'dashboard-lib/public/request/redux-request';
import { Map as ImmutableMap } from 'immutable';
import { fetchAllTeamActions } from 'dashboard-lib/public/team/team-action';
export const teamReducer = createReducer(fetchAllTeamActions, ImmutableMap());